import clsx, { type ClassValue } from 'clsx';

/** Class composition. One helper, so no component invents its own. */
export function cx(...values: ClassValue[]): string {
  return clsx(values);
}
